import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetPartsDeliveryCountRowsQueryVariables = Types.Exact<{
  scope: Types.Mobility_Runs_Bool_Exp;
  window: Types.Mobility_Runs_Bool_Exp;
}>;


export type GetPartsDeliveryCountRowsQuery = { __typename?: 'query_root', upcoming: Array<{ __typename?: 'mobility_runs', id: number, customer_id: number }>, active: Array<{ __typename?: 'mobility_runs', id: number, customer_id: number }>, completed: Array<{ __typename?: 'mobility_runs', id: number, customer_id: number }>, cancelled: Array<{ __typename?: 'mobility_runs', id: number, customer_id: number }> };


export const GetPartsDeliveryCountRowsDocument = gql`
    query getPartsDeliveryCountRows($scope: mobility_runs_bool_exp!, $window: mobility_runs_bool_exp!) {
  upcoming: mobility_runs(
    where: {product_type: {_eq: "parts_delivery"}, _and: [$scope, $window, {_or: [{_and: [{_or: [{fulfillment_type: {_is_null: true}}, {fulfillment_type: {_neq: "external_courier"}}, {parts_delivery_id: {_is_null: true}}]}, {_or: [{status: {_is_null: true}}, {status: {_nin: ["in_transit", "completed", "cancelled", "canceled"]}}]}]}, {_and: [{fulfillment_type: {_eq: "external_courier"}, parts_delivery_id: {_is_null: false}}, {parts_delivery: {_or: [{orchestration_status: {_in: ["NEW", "PENDING", "BOOKING", "RETRY"]}}, {_and: [{_or: [{orchestration_status: {_is_null: true}}, {orchestration_status: {_nin: ["NEW", "PENDING", "BOOKING", "RETRY", "FAILED"]}}]}, {_or: [{delivery_status: {_is_null: true}}, {delivery_status: {_nin: ["arriving_pickup", "picked_up", "arriving_dropoff", "return_in_progress", "delivered", "canceled", "returned"]}}]}]}]}}]}]}]}
  ) {
    id
    customer_id
  }
  active: mobility_runs(
    where: {product_type: {_eq: "parts_delivery"}, _and: [$scope, $window, {_or: [{_and: [{_or: [{fulfillment_type: {_is_null: true}}, {fulfillment_type: {_neq: "external_courier"}}, {parts_delivery_id: {_is_null: true}}]}, {status: {_in: ["in_transit"]}}]}, {_and: [{fulfillment_type: {_eq: "external_courier"}, parts_delivery_id: {_is_null: false}}, {parts_delivery: {_and: [{_or: [{orchestration_status: {_is_null: true}}, {orchestration_status: {_nin: ["NEW", "PENDING", "BOOKING", "RETRY", "FAILED"]}}]}, {delivery_status: {_in: ["arriving_pickup", "picked_up", "arriving_dropoff", "return_in_progress"]}}]}}]}]}]}
  ) {
    id
    customer_id
  }
  completed: mobility_runs(
    where: {product_type: {_eq: "parts_delivery"}, _and: [$scope, $window, {_or: [{_and: [{_or: [{fulfillment_type: {_is_null: true}}, {fulfillment_type: {_neq: "external_courier"}}, {parts_delivery_id: {_is_null: true}}]}, {status: {_in: ["completed"]}}]}, {_and: [{fulfillment_type: {_eq: "external_courier"}, parts_delivery_id: {_is_null: false}}, {parts_delivery: {_and: [{_or: [{orchestration_status: {_is_null: true}}, {orchestration_status: {_nin: ["NEW", "PENDING", "BOOKING", "RETRY", "FAILED"]}}]}, {delivery_status: {_in: ["delivered"]}}]}}]}]}]}
  ) {
    id
    customer_id
  }
  cancelled: mobility_runs(
    where: {product_type: {_eq: "parts_delivery"}, _and: [$scope, $window, {_or: [{_and: [{_or: [{fulfillment_type: {_is_null: true}}, {fulfillment_type: {_neq: "external_courier"}}, {parts_delivery_id: {_is_null: true}}]}, {status: {_in: ["cancelled", "canceled"]}}]}, {_and: [{fulfillment_type: {_eq: "external_courier"}, parts_delivery_id: {_is_null: false}}, {parts_delivery: {_or: [{orchestration_status: {_eq: "FAILED"}}, {_and: [{_or: [{orchestration_status: {_is_null: true}}, {orchestration_status: {_nin: ["NEW", "PENDING", "BOOKING", "RETRY", "FAILED"]}}]}, {delivery_status: {_in: ["canceled", "returned"]}}]}]}}]}]}]}
  ) {
    id
    customer_id
  }
}
    `;

/**
 * __useGetPartsDeliveryCountRowsQuery__
 *
 * To run a query within a React component, call `useGetPartsDeliveryCountRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartsDeliveryCountRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartsDeliveryCountRowsQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *      window: // value for 'window'
 *   },
 * });
 */
export function useGetPartsDeliveryCountRowsQuery(baseOptions: Apollo.QueryHookOptions<GetPartsDeliveryCountRowsQuery, GetPartsDeliveryCountRowsQueryVariables> & ({ variables: GetPartsDeliveryCountRowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartsDeliveryCountRowsQuery, GetPartsDeliveryCountRowsQueryVariables>(GetPartsDeliveryCountRowsDocument, options);
      }
export function useGetPartsDeliveryCountRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartsDeliveryCountRowsQuery, GetPartsDeliveryCountRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartsDeliveryCountRowsQuery, GetPartsDeliveryCountRowsQueryVariables>(GetPartsDeliveryCountRowsDocument, options);
        }
// @ts-ignore
export function useGetPartsDeliveryCountRowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPartsDeliveryCountRowsQuery, GetPartsDeliveryCountRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartsDeliveryCountRowsQuery, GetPartsDeliveryCountRowsQueryVariables>;
export function useGetPartsDeliveryCountRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartsDeliveryCountRowsQuery, GetPartsDeliveryCountRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartsDeliveryCountRowsQuery | undefined, GetPartsDeliveryCountRowsQueryVariables>;
export function useGetPartsDeliveryCountRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartsDeliveryCountRowsQuery, GetPartsDeliveryCountRowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartsDeliveryCountRowsQuery, GetPartsDeliveryCountRowsQueryVariables>(GetPartsDeliveryCountRowsDocument, options);
        }
export type GetPartsDeliveryCountRowsQueryHookResult = ReturnType<typeof useGetPartsDeliveryCountRowsQuery>;
export type GetPartsDeliveryCountRowsLazyQueryHookResult = ReturnType<typeof useGetPartsDeliveryCountRowsLazyQuery>;
export type GetPartsDeliveryCountRowsSuspenseQueryHookResult = ReturnType<typeof useGetPartsDeliveryCountRowsSuspenseQuery>;
export type GetPartsDeliveryCountRowsQueryResult = Apollo.QueryResult<GetPartsDeliveryCountRowsQuery, GetPartsDeliveryCountRowsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * Multiple root fields (upcoming, active, completed, cancelled): returns the full response object.
 * @source {@link src/features/partsDelivery/counts/getPartsDeliveryCountRows.query.gql}
 */
export async function getPartsDeliveryCountRows(
  variables: GetPartsDeliveryCountRowsQueryVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<GetPartsDeliveryCountRowsQuery> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).query<GetPartsDeliveryCountRowsQuery>(
    GetPartsDeliveryCountRowsDocument,
    variables,
    requestOptions
  )
}